/**
 * 숫자 또는 문자열을 CSS px 값으로 변환합니다.
 *
 * @param value - 변환할 값 (숫자 또는 문자열)
 * @returns CSS px 값 문자열
 *
 * @example
 * ```ts
 * toPx(10); // '10px'
 * toPx('10px'); // '10px'
 * toPx('1rem'); // '1rem'
 * ```
 */
export default function toPx(value: number | string): string {
  return typeof value === 'number' ? `${value}px` : value;
}
